$ const {
  snackbar,
  isError,
  responseType
} = input;
$ const {
  content = '',
  open = false,
  actionLinkText = ''
} = snackbar;
<div class="fav-snackbar-container">
  <ebay-snackbar-dialog open=open on-close('onSnackbarClose') on-action("handleAction")>
    <div class="fav-snackbar_row">
      <if(isError)>
        <div class="fav-snackbar__attention-icon">
          <ebay-attention-filled-16-icon/>
        </div>
      </if>
      <div class="fav-snackbar__text">
        ${content}
      </div>
    </div>
    <if(responseType && actionLinkText)>
      <@action accessKey=actionLinkText>
        <span class="fav-snackbar__link">
          ${actionLinkText}
        </span>
      </@action>
    </if>
  </ebay-snackbar-dialog>
</div>